import React from 'react'
import Field from 'components/AddOrEditFormPage/CustomForm/Field'

const title = ({ isEditing, item, isDragging, index }) =>
	isEditing ? (
		<div style={{ paddingTop: 10, paddingBottom: 10 }}>
			<Field
				label="Title"
				property="label"
				statePath={(state) =>
					state.customForm.addOrEdit.sectionsByID[item.id].label
				}
				placeholder="Enter a title"
				sectionID={item.id}
			/>
		</div>
	) : (
		<h3
			style={{
				marginBottom: 0,
				marginTop: '18.72px',
				fontSize: '18.72px',
				padding: 2,
			}}
		>
			{item?.label}
		</h3>
	)

export default title
